document.addEventListener('DOMContentLoaded', function() {
    const popupWrapper = document.getElementById('popupWrapper');
    const emailPopupStage = document.getElementById('emailPopupStage');
    const discountPopupStage = document.getElementById('discountPopupStage');
    const closeButtons = popupWrapper ? popupWrapper.querySelectorAll('.popup-close') : [];
    const newsletterForm = document.getElementById('newsletter_form');
    const copyButton = document.getElementById('copyDiscountCode');
    const discountCodeSpan = document.getElementById('discountCode');

    if (!popupWrapper || !emailPopupStage || !discountPopupStage || closeButtons.length === 0 || !newsletterForm || !copyButton || !discountCodeSpan) {
        console.warn('One or more popup elements not found. Script may not function.');
        return;
    }

    // Removed POPUP_CLOSED_COOKIE as we want it to show every time regardless of closure
    const POPUP_SUBSCRIBED_COOKIE = 'popupSubscribed'; // To remember if subscribed, if needed for the *discount stage*
    const POPUP_DELAY_MS = 2000; // 3 seconds delay before showing initial email popup
    const COOKIE_EXPIRATION_DAYS = 30; // Still useful if you want to remember subscription state for the discount stage

    // --- Cookie Functions (Keep these, as POPUP_SUBSCRIBED_COOKIE might still be useful) ---
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i=0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // --- Popup Display Logic ---
    function showEmailPopup() {
        // --- MODIFICATION START ---
        // Removed the cookie checks here. The popup will now always attempt to show.
        // if (getCookie(POPUP_SUBSCRIBED_COOKIE) || getCookie(POPUP_CLOSED_COOKIE)) {
        //     return;
        // }
        // --- MODIFICATION END ---

        setTimeout(() => {
            // Ensure this only runs on the homepage
            // You might need to adjust '/index' based on your Shopify store's specific homepage path.
            // Some stores might just use '/'
            if (window.location.pathname === '/' || window.location.pathname === '/index') {
                emailPopupStage.style.display = 'block'; // Ensure email stage is visible
                discountPopupStage.style.display = 'none'; // Ensure discount stage is hidden
                popupWrapper.style.display = 'flex'; // Make wrapper visible
                setTimeout(() => {
                    popupWrapper.classList.add('is-visible'); // Trigger CSS animation
                }, 50); // Small delay to ensure display property takes effect before transition
            }
        }, POPUP_DELAY_MS);
    }

    function showDiscountPopup() {
        emailPopupStage.style.display = 'none'; // Hide email stage
        discountPopupStage.style.display = 'block'; // Show discount stage
        popupWrapper.style.display = 'flex'; // Make wrapper visible
        setTimeout(() => {
            popupWrapper.classList.add('is-visible'); // Trigger CSS animation
        }, 50);
        // Set the subscribed cookie immediately
        setCookie(POPUP_SUBSCRIBED_COOKIE, 'true', COOKIE_EXPIRATION_DAYS);
    }

    function closePopup() {
        popupWrapper.classList.remove('is-visible');
        setTimeout(() => {
            popupWrapper.style.display = 'none';
        }, 300); // Match CSS transition duration

        // --- MODIFICATION START ---
        // REMOVED THE LINE THAT SETS THE POPUP_CLOSED_COOKIE
        // setCookie(POPUP_CLOSED_COOKIE, 'true', COOKIE_EXPIRATION_DAYS);
        // --- MODIFICATION END ---
    }

    // --- Initial Check on Load ---
    const urlParams = new URLSearchParams(window.location.search);
    const newsletterSuccess = urlParams.get('customer_posted') === 'true' || urlParams.get('newsletter_form[contact_posted]') === 'true';

    if (newsletterSuccess) {
        // If the URL indicates a successful newsletter submission
        showDiscountPopup();
        // Clean up URL to avoid re-triggering on subsequent refreshes
        history.replaceState(null, '', window.location.pathname + window.location.hash);
    } else {
        // If no success parameter, proceed with showing the email popup after delay
        // This will now always run on the homepage
        showEmailPopup();
    }

    // --- Event Listeners ---
    closeButtons.forEach(button => {
        button.addEventListener('click', closePopup);
    });

    // Copy discount code to clipboard
    copyButton.addEventListener('click', function() {
        const codeToCopy = discountCodeSpan.textContent;
        navigator.clipboard.writeText(codeToCopy).then(() => {
            alert('Discount code copied: ' + codeToCopy);
            const originalText = copyButton.textContent;
            copyButton.textContent = 'Copied!';
            setTimeout(() => {
                copyButton.textContent = originalText;
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
            alert('Failed to copy the code. Please select and copy manually: ' + codeToCopy);
        });
    });

    // Handle initial form state (after page reload)
    // This is crucial for handling validation errors or success messages from Shopify
    if (newsletterForm) {
        const successMessage = newsletterForm.querySelector('.form-message--success');
        const errorMessage = newsletterForm.querySelector('.form-message--error');

        // If the page reloaded with a success message but no URL param (e.g., if JS failed, or unique case)
        if (successMessage && successMessage.offsetParent !== null) { // Check if it's visible
            showDiscountPopup();
        }
        // If there are errors, keep the email popup visible so the user can correct it
        else if (errorMessage && errorMessage.offsetParent !== null) { // Check if it's visible
            popupWrapper.style.display = 'flex';
            popupWrapper.classList.add('is-visible');
            emailPopupStage.style.display = 'block';
            discountPopupStage.style.display = 'none';
        }
    }
});